import LocomotiveScroll from 'locomotive-scroll';

export default defineNuxtPlugin((nuxtApp) => {
    if (import.meta.client) {
        
        let locomotiveScrollInstance = null;
    
        const initLocomotiveScroll = (options) => {
            const scrollContainer = document.querySelector('[data-scroll-container]');
            if (!scrollContainer) {
                console.log('Locomotive Scroll: Контейнер [data-scroll-container] не найден.');
                return null;
            }
    
            if (locomotiveScrollInstance) {
                locomotiveScrollInstance.destroy();
            }
        
            locomotiveScrollInstance = new LocomotiveScroll({
                el: scrollContainer,
                smooth: true,
                ...options,
            });
        
            return locomotiveScrollInstance;
        };
    
        const destroyLocomotiveScroll = () => {
            if (locomotiveScrollInstance) {
                locomotiveScrollInstance.destroy();
                locomotiveScrollInstance = null;
            }
        };
    
        nuxtApp.provide('locomotiveScroll', {
            init: initLocomotiveScroll,
            destroy: destroyLocomotiveScroll,
        });
    }
});